import React, { FC, useState } from 'react'
import classNames from 'classnames'
import { useSelector } from 'react-redux'
import { RootState } from '../../../states/containers/store'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { setPath, setUrlId } from '../../../utils/url'
import { URL } from '../../constants/url'
import { Link, useParams } from 'react-router-dom'
import { isManager } from '../../../utils/role'
import Tips from './Tips'

type LangValue = 'ja' | 'en'

interface Props {
  isOpen: boolean
  toggleCallback: VoidFunction
}

const SideBarSubRisk: FC<Props> = (props) => {
  const {
    isOpen,
    toggleCallback,
  } = props

  const {
    login,
    risk,
  } = useSelector((state: RootState) => state)

  const { language } = useParams<{ language: LangValue }>()

  const [isOpenMember, setIsOpenMember] = useState<boolean>(false)
  const [isOpenTeam, setIsOpenTeam] = useState<boolean>(false)

  return (
    <>
      {
        location.pathname.match(URL.RISK.path) && login.function_enabled_state?.risk_assessment ? (
          <div className="side_sub_wrap">
            <div className="tools">
              <div className="calendar_text">
                <div />
                <button
                  type="button"
                  className={`menu_toggle ${isOpen && "display"}`}
                  onClick={() => toggleCallback()}
                >
                  <div className={`menu ${isOpen && "active"}`}>
                    <FontAwesomeIcon icon={['fas', 'angle-double-left']} />
                  </div>
                </button>
              </div>
            </div>
            <section className="side_sub">
              <div>
                {
                  login.feature_config?.risk_member_report_view ? (
                    <div
                      className="item folder"
                      onClick={() => setIsOpenMember(!isOpenMember)}
                      role="none"
                    >
                      <div className="name_label">
                        <div className="name_area">
                          ユーザーレポート
                        </div>
                        <FontAwesomeIcon
                          icon={['fas', 'angle-down']}
                          className={`arrow_icon ${isOpenMember && "open"}`}
                        />
                      </div>
                    </div>
                  ) : (
                    <Tips
                      description="ユーザーレポート表示権限が設定された場合のみ閲覧できます"
                      className=""
                      icon={false}
                    >
                      <div className="item indent_1 disable">
                        <div className="name_label">
                          <div className="name_area">
                            <FontAwesomeIcon
                              icon={['fas', 'file-alt']}
                              className="icon task"
                            />
                            ユーザーレポート
                          </div>
                        </div>
                      </div>
                    </Tips>
                  )
                }
                <div className={`${isOpenMember || "hidden none"}`}>
                  <Link
                    to={setPath(URL.RISK_TIMELINE.path, language)}
                    className={classNames({
                      active: location.pathname.match(URL.RISK_TIMELINE.path),
                      item: true,
                      indent_1: true,
                    })}
                    style={{
                      borderTop: "solid 1px #21395f",
                    }}
                  >
                    <div className="name_label">
                      <div className="name_area">
                        <FontAwesomeIcon
                          icon={['fas', 'clock']}
                          className="icon task"
                        />
                        タイムライン
                      </div>
                    </div>
                  </Link>
                  <Link
                    to={setPath(URL.RISK_MEMBER_LIST.path, language)}
                    className={classNames({
                      active: location.pathname.match(URL.RISK_MEMBER_LIST.path),
                      item: true,
                      indent_1: true,
                    })}
                  >
                    <div className="name_label">
                      <div className="name_area">
                        <FontAwesomeIcon
                          icon={['fas', 'list']}
                          className="icon task"
                        />
                        ユーザー一覧
                      </div>
                    </div>
                  </Link>
                  {
                    risk.riskMembers?.members.filter((v) => v.active).map((member) => (
                      <React.Fragment key={`side_sub_${member.name}`}>
                        <Link
                          to={setPath(setUrlId(URL.RISK_MEMBER_DETAIL.path, "id", member.id), language)}
                          className={classNames({
                            active: location.pathname.match(setPath(setUrlId(URL.RISK_MEMBER_DETAIL.path, "id", member.id), language)),
                            item: true,
                            indent_1: true,
                          })}
                        >
                          <div className="name_label">
                            <div className="name_area">
                              <img
                                alt=""
                                src={member.profile_image || `/static/images/profile/${member.id % 12 || 0}.jpeg`}
                                className="icon"
                              />
                              {member.name}
                            </div>
                          </div>
                        </Link>
                      </React.Fragment>
                    ))
                  }
                </div>
                {
                  login.feature_config?.risk_team_report_view ? (
                    <div
                      className="item folder"
                      onClick={() => setIsOpenTeam(!isOpenTeam)}
                      role="none"
                    >
                      <div className="name_label">
                        <div className="name_area">
                          チームレポート
                        </div>
                        <FontAwesomeIcon
                          icon={['fas', 'angle-down']}
                          className={`arrow_icon ${isOpenTeam && "open"}`}
                        />
                      </div>
                    </div>
                  ) : (
                    <Tips
                      description="チームレポート表示権限が設定された場合のみ閲覧できます"
                      className=""
                      icon={false}
                    >
                      <div className="item indent_1 disable">
                        <div className="name_label">
                          <div className="name_area">
                            <FontAwesomeIcon
                              icon={['fas', 'file-alt']}
                              className="icon task"
                            />
                            チームレポート
                          </div>
                        </div>
                      </div>
                    </Tips>
                  )
                }
                <div className={`${isOpenTeam || "hidden none"}`}>
                  <Link
                    to={setPath(URL.RISK_TEAM_LIST.path, language)}
                    className={classNames({
                      active: location.pathname.match(URL.RISK_TEAM_LIST.path),
                      item: true,
                      indent_1: true,
                    })}
                  >
                    <div className="name_label">
                      <div className="name_area">
                        <FontAwesomeIcon
                          icon={['fas', 'list']}
                          className="icon task"
                        />
                        チーム一覧
                      </div>
                    </div>
                  </Link>
                  {
                    risk.riskTeams?.teams.map((team) => (
                      <React.Fragment key={`side_sub_${team.name}`}>
                        <Link
                          to={setPath(setUrlId(URL.RISK_TEAM_DETAIL.path, "id", team.id), language)}
                          className={classNames({
                            active: location.pathname.match(setPath(setUrlId(URL.RISK_TEAM_DETAIL.path, "id", team.id), language)),
                            item: true,
                            indent_1: true,
                          })}
                        >
                          <div className="name_label">
                            <div className="name_area">
                              <FontAwesomeIcon
                                icon={['fas', 'users']}
                                className="icon task"
                              />
                              {team.name}
                            </div>
                          </div>
                        </Link>
                      </React.Fragment>
                    ))
                  }
                </div>
              </div>
            </section>
          </div>
        ) : (
          <>
          </>
        )
      }
    </>
  )
}

export default SideBarSubRisk
